import { spotifyClientId } from '../../config';

/**
 * Whether Spotify is offered to the user at all - the route, the settings
 * button, the sign-in prompt in the player.
 *
 * Must agree with whether SpotifyService is in the provider tree in App.tsx.
 * Spotify was switched off from March to September 2026 (after Spotify
 * removed the implicit grant), and during that time the route
 * and button stayed wired up to a context nobody provided: `SpotifyContext`
 * fell back to its `{}` default, so `onClick={spotifyCtx.authorize}` was
 * `onClick={undefined}` and the button did nothing at all - no request, no
 * console line, no error. A control that silently does nothing is worse than
 * one that is not there, hence this flag.
 *
 * A deployment without a Spotify registration (VITE_SPOTIFY_CLIENT_ID
 * unset) has no Spotify at all; the provider may stay in the tree, since a
 * false flag with a provider present is harmless - it is the reverse that
 * bites.
 */
export const spotifyEnabled = spotifyClientId !== '';
